// @flow
import React, { Component } from 'react';
import payform from 'payform';

type Props = {
    input: Object,
    meta: Object,
    active: boolean,
    primaryColor: string,
    handleFocus: Function,
};

export default class ExpiryInput extends Component<Props> {
    expiry: Object;

    componentDidMount() {
        payform.expiryInput(this.expiry);
    }

    render() {
        const {
            input,
            meta: { touched, error, active },
        } = this.props;
        let isFieldInvalid = touched && error && !active;

        let focusColor = '#d7dde5';
        let iconColor = '#d7dde5';
        if (this.props.active) {
            focusColor = this.props.primaryColor
                ? this.props.primaryColor
                : '#00aae6';
        }

        if (this.props.active || this.expiry) {
            iconColor = this.props.primaryColor
                ? this.props.primaryColor
                : '#00aae6';
        }

        if (isFieldInvalid) {
            iconColor = '#f26f59';
        }

        /* BORDER BOTTOM COLOR */
        let borderBottom = `1px solid ${focusColor}`;
        if (isFieldInvalid) {
            borderBottom = `1px solid #f26f59`;
        }
        let className = isFieldInvalid ? 'invalid' : '';

        return (
            <div className="half">
                <input
                    {...input}
                    id="expiry"
                    placeholder=" "
                    type="text"
                    name="expiry"
                    className={className}
                    ref={ref => (this.expiry = ref)}
                    autoComplete="off"
                    onFocus={e => {
                        this.props.handleFocus(e);
                        input.onFocus(e);
                    }}
                    onBlur={e => {
                        this.props.handleFocus(e);
                        input.onBlur(e);
                    }}
                    style={{ borderBottom }}
                />
                <i
                    className="ipic_calendar-expiry"
                    style={{ color: iconColor }}
                />
                <label htmlFor="expiry">MM/YY</label>
                {touched &&
                    error &&
                    !active && (
                        <span className="validation-error">{error}</span>
                    )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/ExpiryInput.js